import React from "react";
import axios from "axios";
import { Button } from "@material-ui/core";
import LineChart from "literacy/assets/assignchart";

class MeaningTutorOnePerformance extends React.Component {
  constructor(props) {
    super(props);
    this.state = { assignScore: null };
  }

  componentDidMount = async () => {
    const doc = await axios.get(
      "/api/literacy/meaning/historyscore/" + this.props.match.params.id
    );
    if (doc.data) {
      this.setState({
        assignScore: doc.data.assignScore,
      });
    }
  };

  render() {
    const { assignScore } = this.state;
    return (
      <div>
        <div className="jumbotron">
          <h2>Learner' Performance</h2>
          <br />
          <Button
            variant="contained"
            style={{ color: "white", backgroundColor: "#107896" }}
            href="/literacy/tutor/meaning/performance"
          >
            Go back
          </Button>
        </div>
        {assignScore ? (
          <LineChart
            data={assignScore}
            title="Meaning Assignment Performance"
            color="#3E517A"
          />
        ) : null}
      </div>
    );
  }
}

export default MeaningTutorOnePerformance;
